//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import footerNav from "@/components/footerNav";
import { Dialog, Toast, Notify } from "vant";
import zwtp from "../../assets/img/zwtp.png";

export default {
  name: "selectSampleHK",
  components: {
    footerNav
  },
  data() {
    return {
      num: 0,
      item: {},
      spuDeptId: "",
      spuDeptName: "",
      loading: false,
      columns: [],
      values: [],
      val1: "",
      val2: "",
      showPicker: false,
      show: true,
      finished: false,
      zwtp,
      start: 0,
      size: 0,
      itemList: []
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.spuDeptId && this.$route.query.spuDeptId != "") {
      this.show = false;
      this.item = JSON.parse(this.$route.query.row);
      this.spuDeptId = this.$route.query.spuDeptId;
      this.onLoad();
    } else {
      this.getQuery();
      this.item = JSON.parse(this.$route.query.row);
    }
  },
  methods: {
    GridCheck(item) {
      item.checked = !item.checked;
      var num = 0;
      this.itemList.forEach(item => {
        if (item.checked) {
          num++;
        }
      });
      this.num = num;
    },
    onSubmit(val) {
      if (val.spuDeptName != "") {
        this.columns.forEach(item => {
          if (item.name == this.val1) {
            item.children.forEach(element => {
              if (element.name == this.val2) {
                this.spuDeptId = element.id;
              }
            });
          }
        });
        this.show = false;
        this.onLoad();
      } else {
        Toast("请选择渠道");
      }
    },
    onConfirm(value, values) {
      this.values = values;
      this.val1 = value[0];
      this.val2 = value[1];
      var val = value[0] + "-" + value[1];
      this.spuDeptName = val;
      this.showPicker = false;
    },
    cancel() {
      this.showPicker = false;
    },
    getQuery() {
      axiosApi
        .getSampleSelectList({ deptType: "channel" })
        .then(sty => {
          sty.content.forEach(item => {
            item.text = item.name;
            item.children.forEach(ele => {
              ele.text = ele.name;
            });
          });
          this.columns = sty.content;
        })
        .catch(err => {});
    },
    onLoad() {
      this.size = this.size + 20;
      axiosApi
        .getSampleSelectDeptSelectList({
          start: this.start,
          size: this.size,
          sampleSelectId: this.item.sampleSelectId,
          spuDeptId: this.spuDeptId,
          orderRules: [
            {
              orderKey: "t1.sampleId",
              desc: true
            }
          ]
        })
        .then(response => {
          if (
            response.content &&
            response.content.list &&
            response.content.list.length > 0
          ) {
            response.content.list.forEach(item => {
              item.checked = false;
              if (
                item.predictedSampleCost &&
                item.predictedSampleCost != "" &&
                item.predictedSampleCost != null
              ) {
              } else {
                item.predictedSampleCost = "暂无";
              }
            });
            var List = JSON.parse(JSON.stringify(this.itemList));
            this.itemList.splice(0, this.itemList.length);
            this.itemList = response.content.list;
            this.itemList.forEach(item => {
              List.forEach(element => {
                if (element.sampleSelectDetailId == item.sampleSelectDetailId) {
                  item.checked = element.checked;
                }
              });
            });
          } else {
            this.itemList = [];
          }
          this.loading = false;
          if (this.itemList.length == response.content.total) {
            this.finished = true;
          }
        });
    },
    selected() {
      this.$router.push({
        name: "activitiesSelected",
        query: {
          row: this.$route.query.row,
          spuDeptId: this.spuDeptId
        }
      });
    },
    bottomClick(type) {
      if (type == "1") {
        this.$router.push({
          name: "activitiesSelection"
        });
      } else {
        if (this.num != 0) {
          var list = JSON.parse(this.$route.query.row);
          var arr = [];
          this.itemList.forEach(item => {
            if (item.checked) {
              arr.push({ sampleSelectDetailId: item.sampleSelectDetailId });
            }
          });
          axiosApi
            .getSampleSelectDeptConfirm({
              sampleSelectId: list.sampleSelectId,
              spuDeptId: this.spuDeptId,
              sampleSelectColorList: arr
            })
            .then(res => {
              Notify({ type: "success", message: "选样确定" });
              this.num = 0;
              this.onLoad();
            })
            .catch(err => {});
        } else {
          Notify({ type: "danger", message: "请选择" });
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/selectSampleHK.vue